import { baseApi } from "./baseApi";

const GENERAL_LEDGER_BASE_URL = "/general-ledger";

export const generalLedgerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listGeneralLedger: builder.query({
      query: (params) => ({
        url: GENERAL_LEDGER_BASE_URL,
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "GeneralLedger",
                id: _id,
              })),
              { type: "GeneralLedger", id: "LIST" },
            ]
          : [{ type: "GeneralLedger", id: "LIST" }],
    }),

    getGeneralLedgerById: builder.query({
      query: (id) => ({
        url: `${GENERAL_LEDGER_BASE_URL}/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "GeneralLedger", id }],
    }),

    listGLSalesReport: builder.query({
      query: (params) => ({
        url: `${GENERAL_LEDGER_BASE_URL}/sales-report`,
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "GeneralLedger",
                id: _id,
              })),
              { type: "GeneralLedger", id: "SALES_REPORT" },
            ]
          : [{ type: "GeneralLedger", id: "SALES_REPORT" }],
    }),
  }),
});

export const {
  useLazyListGeneralLedgerQuery,
  useGetGeneralLedgerByIdQuery,
  useLazyListGLSalesReportQuery,
} = generalLedgerApi;
